import { render } from "./video-item.vue?vue&type=template&id=f4d393f0&scoped=true"
import script from "./video-item.vue?vue&type=script&lang=js"
export * from "./video-item.vue?vue&type=script&lang=js"

import "./video-item.vue?vue&type=style&index=0&id=f4d393f0&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d393f0"]])

export default __exports__